import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
	beforeLoad: ({ context }) => {
		if (context.auth.isSignedIn) {
			throw redirect({ to: '/company' })
		} else {
			throw redirect({ to: '/auth' })
		}
	},
	component: () => null,
})
